import React from "react";
import Overview from "./Overview";

const DeliveryReturn = () => {
  return <Overview />;
};

export default DeliveryReturn;
